/**
 * 把同一语言的多种写法 (zh / zh_hans / zh-CN / ja_JP / en_US) normalize 到一致 key,
 * 跨 desktop / 后端 / web 比对 lang 时统一用 normalized 值。
 *
 * - 简体中文家族: zh / zh_hans / zh_cn / zh_sg / zh-CN ... → 'zh'
 * - 繁体中文家族: zh_hant / zh_tw / zh_hk / zh_mo / zh-TW ... → 'zh_hant'
 * - 其他: 取下划线/连字符前的第一段 (en_US → en, ja_JP → ja)
 */
export function normalizeLang(lang: string): string {
  const lower = lang.toLowerCase().replace(/-/g, '_');
  if (
    lower === 'zh'
    || lower === 'zh_hans'
    || lower === 'zh_cn'
    || lower === 'zh_sg'
  ) return 'zh';
  if (
    lower === 'zh_hant'
    || lower === 'zh_tw'
    || lower === 'zh_hk'
    || lower === 'zh_mo'
  ) return 'zh_hant';
  return lower.split('_')[0];
}
